<template>
  <div class="flex flex-wrap col-12 border-box white-bg body-padding-desktop">
    <div class="flex col-12 h3 my2">{{ offer.name }}</div>
    <div class="col-12 h5" v-html="offer.subscriptionDescription"></div>
    <div v-for="(price, index) in getOfferPrices" :key="index" class="flex flex-column col-12">
      <div class="my2">
        <div class="flex flex-wrap col-12 justify-between" @click="handleSelectedTariff(price)">
          <div class="flex flex-column h5">
            <div>
              <input type="radio" :checked="isSelected(price)" :name="offer.name" @input="handleSelectedTariff(price)">
              <span class="h5 bold">{{ price.label }}</span>
            </div>
            <div class="h6 italic text-pad" v-html="tariffDescription(price)"></div>
          </div>
          <div>
            <span :class="['h5 price-padding', {'crossed': computePromo(price).canShow}]"> {{ computeTariffPrice(price) }}</span>
            <span v-if="computePromo(price).canShow" class="h5 price-padding"> {{ computePromo(price).price / 100 }}</span>
            <span>€/mois</span>
          </div>
        </div>
        <div v-if="isSelected(price)" class="flex flex-wrap col-12 pl3">
          <div v-for="(option, i) in tariffOptions" :key="i" class="flex col-12">
            <div class="flex flex-column col-12">
              <div>
                <input
                  :key="`checkbox-options-${i}`"
                  :checked="isOptionChecked(option)"
                  type="checkbox"
                  :disabled="isMandatory(option)"
                  :class="[{'mandatory-checkbox': isMandatory(option)}]"
                  @input="manageOption(option)"
                >
                <span class="h5 bold">{{ option.name }}</span>
              </div>
              <span class="h6 text-pad italic"> {{ mandatoryLabel(option) }} </span>
              <span class="h6 text-pad italic"> {{ option.tdaDescription }} </span>
            </div>
            <span class="h5 price-padding"> {{ computeOptionPrice(option) }}€ </span>
            <span v-if="option.detail && option.detail.recurring" class="h5 price-padding"> /mois </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computeTariffOptions, computePromo, computeAvailableOptions, computeSamePricePeriodOptions } from '@/utils/logics';
import { optionTypes } from '@/utils/utils';

export default {
  data () {
    return {
      offer: this.$store.state.offerInfo,
      optionTypes: optionTypes
    };
  },
  computed: {
    isSubscriptionTDA () {
      return this.$store.state.subscriptionTDA;
    },
    getOfferPrices () {
      return this.offer && this.offer.detail && this.offer.detail.prices ? [...this.offer.detail.prices].sort((a, b) => a.price - b.price) : [];
    },
    cartItem () {
      return this.$store.state.cartItem;
    },
    tariffs () {
      return this.cartItem && this.cartItem.tariffs && this.cartItem.tariffs.length ? this.cartItem.tariffs : [];
    },
    tariffOptions () {
      return this.tariffs && this.tariffs.length ? this.tariffs[0].availableOptions : [];
    },
    isRecurring () {
      return this.offer.detail.recurring;
    },
    selectedTariff () {
      return this.tariffs[0] || {};
    },
    isInternalSession () {
      return this.$store.state.siteInfo.is_internal_session;
    },
    isPension () {
      return !!(this.offer && this.offer.isPension);
    }
  },
  mounted () {
    this.$store.commit('setSubscriptionHeader', { title: 'Abonnement', subtitle: 'Choisissez votre tarif et vos options' });

    if (this.getOfferPrices && this.getOfferPrices.length) {
      this.handleSelectedTariff(this.getOfferPrices[this.getOfferPrices.length - 1]);
    }
  },
  methods: {
    computePromo,
    computeTariffPrice (price) {
      return parseFloat(price.price / 100).toFixed(2);
    },
    computeOptionPrice (option) {
      return parseFloat(option.price.price / 100).toFixed(2);
    },
    handleSelectedTariff (price) {
      const availableOpt = this.isInternalSession ? computeSamePricePeriodOptions(this.offer.options, price) : computeAvailableOptions(this.offer.options, price).filter(option => option?.price);
      const tariff = {
        ...price,
        availableOptions: computeTariffOptions(availableOpt, price),
        quantity: 1,
        options: []
      };

      if (tariff.availableOptions) {
        tariff.availableOptions.forEach(option => {
          if (option.quantity && option.optionType === this.optionTypes.MANDATORY) {
            tariff.options.push(option);
          }
        });
      }
      this.$store.commit('setCartItem', {
        ...this.cartItem,
        tariffs: [tariff]
      });
      this.$store.commit('setPromoCampaign', null);
    },
    manageOption (option) {
      const tariffs = [...this.tariffs];
      const tariffIndex = tariffs.findIndex(t => t.tariffCategoryCode === option.price.tariffCategoryCode);
      const tariff = tariffs[tariffIndex];

      let optionIndex = null;

      if (this.isInternalSession) {
        optionIndex = tariff.options.findIndex(o => o.product.uuid === option.product.uuid);
      } else {
        optionIndex = tariff.options.findIndex(o => o.price.tariffCode === option.price.tariffCode && o.price.tariffCategoryCode === option.price.tariffCategoryCode);
      }

      if (optionIndex !== -1) {
        option.quantity = 0;
        tariff.options.splice(optionIndex, 1);

        tariffs[tariffIndex] = tariff;
        this.$store.commit('setCartItem', { ...this.cartItem, tariffs });
        return;
      }

      if (this.isInternalSession) {
        option.product_uuid = option.product?.uuid;
        const selectedOffer = (option.product?.dynamo_offers || []).find(o => (o.detail?.prices || []).some(p => p.period.uuid === option.price.period.uuid && p.priceCategory.uuid === option.price.priceCategory.uuid));
        option.horanet_product_code = selectedOffer?.uuid;

        if (this.isPension) {
          option.withReservation = selectedOffer?.withReservation;
          option.reservationMetric = selectedOffer?.reservationMetric;
          option.reservationAmount = selectedOffer?.reservationAmount;

          /*  Only one option when its a Pension */
          tariff.options = [];
          tariff.availableOptions = tariff.availableOptions.map(o => {
            if (o.product.uuid === option.product.uuid) {
              return { ...o, quantity: 1 };
            }
            return { ...o, quantity: null };
          });
        }
      }

      option.quantity = 1;
      tariff.options.push(option);
      tariffs[tariffIndex] = tariff;
      this.$store.commit('setCartItem', { ...this.cartItem, tariffs });
    },
    isOptionChecked (option) {
      return option.quantity > 0 && option.optionType !== this.optionTypes.OPTIONAL;
    },
    isSelected (price) {
      if (this.isInternalSession) {
        return price.uuid === this.selectedTariff.uuid;
      }
      return price.tariffCode === this.selectedTariff.tariffCode;
    },
    isMandatory (option) {
      return option.optionType === this.optionTypes.MANDATORY;
    },
    mandatoryLabel (option) {
      return option.optionType === this.optionTypes.MANDATORY ? 'Obligatoire' : 'Facultatif';
    },
    tariffDescription (price) {
      const tariffIndex = (this.offer.selectedHoranetTariffs || []).findIndex(tariff => tariff.codeTariff === price.tariffCode);
      if (tariffIndex !== -1) {
        return this.offer.selectedHoranetTariffs[tariffIndex].description;
      }
      return null;
    }
  }
};
</script>
<style lang="scss" scoped>

input[type="checkbox"]::after {
  border-radius: 50%;
}

input[type="radio"], input[type="checkbox"] {
  margin: 0.5rem;
}

input[type="radio"]::after, input[type="checkbox"]::after{
  border: 1px solid var(--darkish-grey);
}

input[type="radio"]:checked::after, input[type="checkbox"]:checked::after{
  box-shadow: inset 0 0 0 2px var(--white);
  background-color: var(--strong-blue);
  border-color: var(--strong-blue)
}

.mandatory-checkbox:checked::after {
  background-color: var(--darkish-grey) !important;
  border-color: var(--darkish-grey) !important;
}

.text-pad {
  padding-left: 1.75rem;
  padding-bottom: 0.75rem;
}

.text-pad :deep(p) {
  margin: 0px;
  font-size: 0.9rem;
  font-style: italic;
}

.price-padding {
  padding-top: 2px;
}
</style>
